module.exports = __webpack_public_path__ + "38e8bb22232f0c55db230746c383f398.pdf";